import { FC, HTMLAttributes, useEffect } from "react";
import { useStyles } from "./EssentialPack.style";
import { useGamepadContext } from "../../contexts/GamepadProvider";
import { onGameListMoveAction } from "../../models/gamepad";
import { HeroBanner } from "../../components/common/HeroBanner";
import { useQuery } from "@apollo/client";
import { pageAaaGQL, Query } from "@onmo/graphql/graphql";
import { GameCategory } from "../../components/common/GameCategory";
import { MyLibraryCategory } from "../../components/common/MyLibraryCategory/MyLibraryCategory";
import map from "lodash-es/map";
import { isTV } from "../../utils/platform";
import { getMediaSizeScale } from "../../models/screen";
import { selectIsAuthenticated } from "@onmo/auth";
import { useAppSelector } from "../../components/hooks";

const EssentialPack: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { setCallback, cleanup } = useGamepadContext();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { data: pageData } = useQuery<Query>(pageAaaGQL, {
    variables: { input: { page: "essential" } },
  });

  const defaultCardWidth = isTV ? 320 * getMediaSizeScale() : undefined;

  useEffect(() => {
    setCallback({
      onMoveAction: onGameListMoveAction,
    });

    return () => {
      cleanup();
    };
  }, [cleanup, setCallback]);

  return (
    <div className={classes.root}>
      <div className={classes.rootContent} id="essential-pack">
        <HeroBanner type="essentialPack" />
        <div className={classes.content}>
          {isAuthenticated && (
            <MyLibraryCategory
              gameCategory="PID"
              group="my-library-pid"
              defaultCardWidth={defaultCardWidth}
            />
          )}
          {map(pageData?.page?.items, (section) => (
            <GameCategory
              key={section?.id}
              section={section}
              defaultCardWidth={defaultCardWidth}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EssentialPack;
